"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ramda = require("ramda");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _classnames = _interopRequireDefault(require("classnames"));

var _gift = require("../../store/gift/gift.selector");

var _useTrackGiftingFlow = require("../../hooks/useTrackGiftingFlow");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    research: {
      backgroundColor: 'var(--Fruit-Salad-10)',
      padding: spacing(2)
    },
    researchIcon: {
      color: '#4a974a',
      marginTop: spacing(1),
      marginRight: spacing(2)
    },
    profileLink: {
      marginTop: spacing(1),
      marginRight: spacing(1),
      backgroundColor: palette.common.white,
      border: "1px solid ".concat(palette.divider),
      borderRadius: 5,
      padding: '11px 24px',
      fontSize: 16,
      fontWeight: 'bold',
      lineHeight: 1.5,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textTransform: 'capitalize',
      textDecoration: 'none !important'
    },
    profileLinkIcon: {
      marginRight: 5
    },
    reasoning: {
      '& span': {
        fontWeight: 'bold'
      },
      '& a': {
        textDecoration: 'underline'
      }
    }
  };
});

var getProfileIcon = function getProfileIcon(profile) {
  return (0, _ramda.propOr)('globe', profile.toLowerCase(), {
    facebook: ['fab', 'facebook-square'],
    pinterest: ['fab', 'pinterest-square'],
    twitter: ['fab', 'twitter-square'],
    youtube: ['fab', 'youtube'],
    linkedin: ['fab', 'linkedin'],
    instagram: ['fab', 'instagram']
  });
};

var getProfileTitle = function getProfileTitle(profile) {
  return (0, _ramda.propOr)(profile, profile.toLowerCase(), {
    linkedin: 'LinkedIn'
  });
};

var SelectProductNotice = function SelectProductNotice(_ref2) {
  var recipientName = _ref2.recipientName;
  var classes = useStyles();
  var profiles = (0, _reactRedux.useSelector)(_gift.getGiftRecipientProfiles, _reactRedux.shallowEqual);
  var tags = (0, _react.useMemo)(function () {
    return (0, _ramda.pipe)((0, _ramda.map)((0, _ramda.prop)('tags')), _ramda.flatten, _ramda.uniq)(profiles);
  }, [profiles]);
  var socialNetworks = (0, _react.useMemo)(function () {
    return (0, _ramda.pipe)((0, _ramda.map)((0, _ramda.prop)('title')), (0, _ramda.converge)(function (firstPart, secondPart) {
      return "".concat(firstPart.length ? "".concat(firstPart.join(', '), " and ") : '').concat(secondPart);
    }, [(0, _ramda.take)(profiles.length - 1), (0, _ramda.takeLast)(1)]))(profiles);
  }, [profiles]);
  var researchNotice = tags.length ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Based on our research, ", recipientName, " shows us on ", socialNetworks, " that they like", ' ', tags.map(function (tag, i) {
    return /*#__PURE__*/_react.default.createElement("b", {
      key: tag
    }, i !== 0 ? ', ' : '', tag);
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Want some more insight? Check out ", recipientName, "\u2019s online presence:");
  var trackSocialLink = (0, _useTrackGiftingFlow.useTrackGiftingFlowSocialLinkVisited)();
  var handleLinkClick = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    var profile = event.currentTarget.dataset.profile;
    trackSocialLink(_useTrackGiftingFlow.GIFTING_TRACK_TABS.SEND, profile);
    window.open(event.currentTarget.href, '_blank');
  }, [trackSocialLink]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    wrap: "nowrap",
    className: classes.research
  }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    icon: "magic",
    className: classes.researchIcon
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)(classes.reasoning, 'Body-Regular-Left-Static')
  }, profiles.length === 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, recipientName, " does not share a lot publicly, but we have some great gifts that ", recipientName, " would love!") : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, researchNotice, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    className: classes.profileLinks,
    container: true,
    direction: "row"
  }, profiles.map(function (_ref3) {
    var title = _ref3.title,
        url = _ref3.url;
    return /*#__PURE__*/_react.default.createElement(_material.Link, {
      "data-testid": "SendGift-SelectProposedProduct-ProfileLink",
      "data-profile": title,
      className: classes.profileLink,
      key: title,
      onClick: handleLinkClick,
      href: url
    }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
      className: classes.profileLinkIcon,
      icon: getProfileIcon(title)
    }), getProfileTitle(title));
  })))));
};

SelectProductNotice.propTypes = {
  recipientName: _propTypes.default.string.isRequired
};
var _default = SelectProductNotice;
exports.default = _default;